
import { postRequest } from "../httpMethods";


export const postSendOtp = (payload) =>
    postRequest(`otp/send`, payload);

export const postVerifyOtp = (payload) =>
    postRequest(`otp/verify`, payload);

export const postVerifyOtpApt = (payload) =>
    postRequest(`otp/verify-apt`, payload);

export const postResendOtp = (payload) =>
    postRequest(`otp/resend`, payload);

export const postWishlist = (payload) =>
    postRequest(`v1/wishlist`, payload);

export const postCart = (payload) =>
    postRequest(`v1/cart`, payload);

export const postAddress = (payload) =>
    postRequest(`v1/address`, payload);

export const postPurchaseOrder = (payload) =>
    postRequest(`v1/purchase/create/order`, payload);

export const postVerifyPurchase = (payload) =>
    postRequest(`v1/purchase/verify/payment`, payload);

export const postOrderDetails = (payload) =>
    postRequest(`orders`, payload, window._env_?.SKILLBOX_PRODUCT);

export const postShippingMethods = (payload) =>
    postRequest(`cart/shipping-methods`, payload, window._env_?.SKILLBOX_PRODUCT);

export const postActivityLmsOrder = (payload) =>
    postRequest(`v1/activity-lms/purchase/create/order`, payload);

export const postVerifyActivityLmsPurchase = (payload) =>
    postRequest(`v1/activity-lms/purchase/verify/payment`, payload);

